type Props = { width?: number; height?: number; fill?: string };
const SentIcon = ({ width = 40, height = 40, fill = "none" }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 128 128"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#000000"
        stroke-opacity="0.00"
        stroke-width="0.3"
      >
        <path d="M 0.00 128.00 L 128.00 128.00 L 128.00 0.00 L 0.00 0.00 L 0.00 128.00 M 82.00 36.00 C 83.23 35.81 84.75 35.95 86.00 36.00 C 86.84 36.03 90.06 35.42 90.00 37.00 C 94.22 37.51 94.20 42.53 94.00 46.00 C 105.55 48.74 106.89 61.78 105.00 72.00 C 103.11 82.22 110.08 98.42 99.00 102.00 C 98.76 102.26 96.39 102.00 96.00 102.00 C 73.46 102.00 50.49 103.31 28.00 102.00 C 27.16 101.95 23.94 102.59 24.00 101.00 C 22.72 100.79 23.07 98.91 23.00 98.00 C 22.91 96.68 23.00 95.32 23.00 94.00 C 23.00 80.67 23.00 67.33 23.00 54.00 C 24.00 54.00 25.00 54.00 26.00 54.00 C 26.62 53.03 31.62 48.12 33.00 49.00 C 32.44 44.99 33.02 40.69 34.00 37.00 C 35.56 37.41 36.69 36.54 38.00 36.00 C 39.54 35.75 41.43 35.95 43.00 36.00 C 44.73 36.05 46.84 35.84 49.00 36.00 C 55.05 34.08 58.52 26.43 65.00 26.00 C 73.23 25.45 75.44 34.36 82.00 36.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#E67621"
        stroke-opacity="0.91"
        stroke-width="0.3"
      >
        <path d="M 49.00 36.00 C 57.89 36.67 68.39 37.56 78.00 37.00 C 73.43 36.11 69.03 26.96 65.00 26.00 C 58.52 26.43 55.05 34.08 49.00 36.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B94902"
        stroke-opacity="0.81"
        stroke-width="0.3"
      >
        <path d="M 78.00 37.00 C 79.54 36.91 81.08 36.14 82.00 36.00 C 75.44 34.36 73.23 25.45 65.00 26.00 C 69.03 26.96 73.43 36.11 78.00 37.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#FDCE3F"
        stroke-opacity="0.99"
        stroke-width="0.3"
      >
        <path d="M 33.00 49.00 C 33.17 50.22 33.95 52.17 34.00 54.00 C 34.04 55.52 33.62 57.53 34.00 59.00 C 41.02 64.02 49.88 70.01 56.00 76.00 C 56.44 75.84 57.00 76.00 57.00 76.00 C 59.54 75.40 61.22 74.01 64.01 74.01 C 66.80 74.00 67.30 77.61 70.00 76.00 C 70.37 75.78 71.00 76.00 71.00 76.00 C 75.55 69.49 84.65 64.63 91.00 60.00 C 92.71 55.79 92.16 40.08 89.00 37.00 C 87.36 37.20 86.92 36.18 86.00 36.00 C 84.75 35.95 83.23 35.81 82.00 36.00 C 81.08 36.14 79.54 36.91 78.00 37.00 C 68.39 37.56 57.89 36.67 49.00 36.00 C 46.84 35.84 44.73 36.05 43.00 36.00 C 42.31 36.06 38.31 35.96 38.00 36.00 C 36.69 36.54 35.56 37.41 34.00 37.00 C 33.02 40.69 32.44 44.99 33.00 49.00 M 67.00 63.00 C 80.44 58.22 65.49 39.67 55.92 49.92 C 46.35 60.17 56.35 71.66 68.00 70.00 C 62.79 72.06 55.77 71.59 52.25 66.75 C 48.72 61.92 49.63 55.45 52.77 50.77 C 55.91 46.09 63.13 43.41 68.02 45.98 C 72.92 48.55 76.31 55.35 73.67 60.67 C 71.03 65.99 64.29 64.32 59.97 64.97 C 55.66 65.62 52.84 54.06 60.25 52.25 C 67.65 50.43 69.22 55.22 67.00 63.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#C86A11"
        stroke-opacity="0.09"
        stroke-width="0.3"
      >
        <path d="M 43.00 36.00 C 41.43 35.95 39.54 35.75 38.00 36.00 C 38.31 35.96 42.31 36.06 43.00 36.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#BA5905"
        stroke-opacity="0.13"
        stroke-width="0.3"
      >
        <path d="M 89.00 37.00 C 89.49 36.94 90.00 37.00 90.00 37.00 C 90.06 35.42 86.84 36.03 86.00 36.00 C 86.92 36.18 87.36 37.20 89.00 37.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B84801"
        stroke-opacity="0.84"
        stroke-width="0.3"
      >
        <path d="M 91.00 60.00 C 93.37 58.27 95.50 56.44 98.00 55.00 C 94.40 54.22 91.70 52.85 93.00 48.00 C 102.48 51.39 101.21 59.95 101.00 69.00 C 100.79 78.05 101.16 89.71 101.00 99.00 C 91.32 90.78 80.18 84.45 71.00 76.00 C 71.00 76.00 70.37 75.78 70.00 76.00 C 70.71 82.61 81.10 83.78 84.23 88.77 C 87.36 93.76 96.69 95.89 99.00 101.00 C 99.19 101.41 99.00 102.00 99.00 102.00 C 110.08 98.42 103.11 82.22 105.00 72.00 C 106.89 61.78 105.55 48.74 94.00 46.00 C 94.20 42.53 94.22 37.51 90.00 37.00 C 90.00 37.00 89.49 36.94 89.00 37.00 C 92.16 40.08 92.71 55.79 91.00 60.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#EB8326"
        stroke-opacity="1.00"
        stroke-width="0.3"
      >
        <path d="M 67.00 63.00 C 69.22 55.22 67.65 50.43 60.25 52.25 C 52.84 54.06 55.66 65.62 59.97 64.97 C 64.29 64.32 71.03 65.99 73.67 60.67 C 76.31 55.35 72.92 48.55 68.02 45.98 C 63.13 43.41 55.91 46.09 52.77 50.77 C 49.63 55.45 48.72 61.92 52.25 66.75 C 55.77 71.59 62.79 72.06 68.00 70.00 C 56.35 71.66 46.35 60.17 55.92 49.92 C 65.49 39.67 80.44 58.22 67.00 63.00 M 65.00 53.00 C 67.53 54.36 63.42 64.91 59.32 62.66 C 55.22 60.42 61.56 51.15 65.00 53.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#E57520"
        stroke-opacity="1.00"
        stroke-width="0.3"
      >
        <path d="M 91.00 60.00 C 84.65 64.63 75.55 69.49 71.00 76.00 C 80.18 84.45 91.32 90.78 101.00 99.00 C 101.16 89.71 100.79 78.05 101.00 69.00 C 101.21 59.95 102.48 51.39 93.00 48.00 C 91.70 52.85 94.40 54.22 98.00 55.00 C 95.50 56.44 93.37 58.27 91.00 60.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#E67621"
        stroke-opacity="0.79"
        stroke-width="0.3"
      >
        <path d="M 26.00 54.00 C 26.49 54.06 27.00 54.00 27.00 54.00 C 29.33 54.00 31.67 54.00 34.00 54.00 C 33.95 52.17 33.17 50.22 33.00 49.00 C 31.62 48.12 26.62 53.03 26.00 54.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#FCCA3E"
        stroke-opacity="1.00"
        stroke-width="0.3"
      >
        <path d="M 65.00 53.00 C 61.56 51.15 55.22 60.42 59.32 62.66 C 63.42 64.91 67.53 54.36 65.00 53.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#E77621"
        stroke-opacity="0.97"
        stroke-width="0.3"
      >
        <path d="M 23.00 94.00 C 23.16 94.92 24.73 96.39 24.00 98.00 C 35.90 93.71 44.07 80.30 56.00 76.00 C 49.88 70.01 41.02 64.02 34.00 59.00 C 31.54 57.25 28.89 56.90 27.00 54.00 C 27.00 54.00 26.49 54.06 26.00 54.00 C 25.00 54.00 24.00 54.00 23.00 54.00 C 23.00 67.33 23.00 80.67 23.00 94.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#BB4D04"
        stroke-opacity="1.00"
        stroke-width="0.3"
      >
        <path d="M 34.00 59.00 C 33.62 57.53 34.04 55.52 34.00 54.00 C 31.67 54.00 29.33 54.00 27.00 54.00 C 28.89 56.90 31.54 57.25 34.00 59.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#E77621"
        stroke-opacity="0.97"
        stroke-width="0.3"
      >
        <path d="M 57.00 76.00 C 54.33 82.39 45.64 83.38 41.30 88.30 C 36.96 93.23 29.40 96.41 25.00 101.00 C 26.66 100.80 27.04 101.79 28.00 102.00 C 50.49 103.31 73.46 102.00 96.00 102.00 C 96.55 101.88 97.82 100.20 99.00 101.00 C 96.69 95.89 87.36 93.76 84.23 88.77 C 81.10 83.78 70.71 82.61 70.00 76.00 C 67.30 77.61 66.80 74.00 64.01 74.01 C 61.22 74.01 59.54 75.40 57.00 76.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#BD4D04"
        stroke-opacity="0.98"
        stroke-width="0.3"
      >
        <path d="M 24.00 98.00 C 23.56 98.16 23.00 98.00 23.00 98.00 C 23.07 98.91 22.72 100.79 24.00 101.00 C 24.49 101.08 25.00 101.00 25.00 101.00 C 29.40 96.41 36.96 93.23 41.30 88.30 C 45.64 83.38 54.33 82.39 57.00 76.00 C 57.00 76.00 56.44 75.84 56.00 76.00 C 44.07 80.30 35.90 93.71 24.00 98.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#E77721"
        stroke-opacity="0.47"
        stroke-width="0.3"
      >
        <path d="M 23.00 98.00 C 23.00 98.00 23.56 98.16 24.00 98.00 C 24.73 96.39 23.16 94.92 23.00 94.00 C 23.00 95.32 22.91 96.68 23.00 98.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#DE6F1C"
        stroke-opacity="0.13"
        stroke-width="0.3"
      >
        <path d="M 28.00 102.00 C 27.04 101.79 26.66 100.80 25.00 101.00 C 25.00 101.00 24.49 101.08 24.00 101.00 C 23.94 102.59 27.16 101.95 28.00 102.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#E67721"
        stroke-opacity="0.62"
        stroke-width="0.3"
      >
        <path d="M 96.00 102.00 C 96.39 102.00 98.76 102.26 99.00 102.00 C 99.00 102.00 99.19 101.41 99.00 101.00 C 97.82 100.20 96.55 101.88 96.00 102.00 Z" />
      </g>
      <g fill="#000000" fill-opacity="0.00" stroke="None">
        <path d="M 0.00 128.00 L 128.00 128.00 L 128.00 0.00 L 0.00 0.00 L 0.00 128.00 M 82.00 36.00 C 83.23 35.81 84.75 35.95 86.00 36.00 C 86.84 36.03 90.06 35.42 90.00 37.00 C 94.22 37.51 94.20 42.53 94.00 46.00 C 105.55 48.74 106.89 61.78 105.00 72.00 C 103.11 82.22 110.08 98.42 99.00 102.00 C 98.76 102.26 96.39 102.00 96.00 102.00 C 73.46 102.00 50.49 103.31 28.00 102.00 C 27.16 101.95 23.94 102.59 24.00 101.00 C 22.72 100.79 23.07 98.91 23.00 98.00 C 22.91 96.68 23.00 95.32 23.00 94.00 C 23.00 80.67 23.00 67.33 23.00 54.00 C 24.00 54.00 25.00 54.00 26.00 54.00 C 26.62 53.03 31.62 48.12 33.00 49.00 C 32.44 44.99 33.02 40.69 34.00 37.00 C 35.56 37.41 36.69 36.54 38.00 36.00 C 39.54 35.75 41.43 35.95 43.00 36.00 C 44.73 36.05 46.84 35.84 49.00 36.00 C 55.05 34.08 58.52 26.43 65.00 26.00 C 73.23 25.45 75.44 34.36 82.00 36.00 Z" />
      </g>
      <g fill="#E67621" fill-opacity="0.91" stroke="None">
        <path d="M 49.00 36.00 C 57.89 36.67 68.39 37.56 78.00 37.00 C 73.43 36.11 69.03 26.96 65.00 26.00 C 58.52 26.43 55.05 34.08 49.00 36.00 Z" />
      </g>
      <g fill="#B94902" fill-opacity="0.81" stroke="None">
        <path d="M 78.00 37.00 C 79.54 36.91 81.08 36.14 82.00 36.00 C 75.44 34.36 73.23 25.45 65.00 26.00 C 69.03 26.96 73.43 36.11 78.00 37.00 Z" />
      </g>
      <g fill="#FDCE3F" fill-opacity="0.99" stroke="None">
        <path d="M 33.00 49.00 C 33.17 50.22 33.95 52.17 34.00 54.00 C 34.04 55.52 33.62 57.53 34.00 59.00 C 41.02 64.02 49.88 70.01 56.00 76.00 C 56.44 75.84 57.00 76.00 57.00 76.00 C 59.54 75.40 61.22 74.01 64.01 74.01 C 66.80 74.00 67.30 77.61 70.00 76.00 C 70.37 75.78 71.00 76.00 71.00 76.00 C 75.55 69.49 84.65 64.63 91.00 60.00 C 92.71 55.79 92.16 40.08 89.00 37.00 C 87.36 37.20 86.92 36.18 86.00 36.00 C 84.75 35.95 83.23 35.81 82.00 36.00 C 81.08 36.14 79.54 36.91 78.00 37.00 C 68.39 37.56 57.89 36.67 49.00 36.00 C 46.84 35.84 44.73 36.05 43.00 36.00 C 42.31 36.06 38.31 35.96 38.00 36.00 C 36.69 36.54 35.56 37.41 34.00 37.00 C 33.02 40.69 32.44 44.99 33.00 49.00 M 67.00 63.00 C 80.44 58.22 65.49 39.67 55.92 49.92 C 46.35 60.17 56.35 71.66 68.00 70.00 C 62.79 72.06 55.77 71.59 52.25 66.75 C 48.72 61.92 49.63 55.45 52.77 50.77 C 55.91 46.09 63.13 43.41 68.02 45.98 C 72.92 48.55 76.31 55.35 73.67 60.67 C 71.03 65.99 64.29 64.32 59.97 64.97 C 55.66 65.62 52.84 54.06 60.25 52.25 C 67.65 50.43 69.22 55.22 67.00 63.00 Z" />
      </g>
      <g fill="#C86A11" fill-opacity="0.09" stroke="None">
        <path d="M 43.00 36.00 C 41.43 35.95 39.54 35.75 38.00 36.00 C 38.31 35.96 42.31 36.06 43.00 36.00 Z" />
      </g>
      <g fill="#BA5905" fill-opacity="0.13" stroke="None">
        <path d="M 89.00 37.00 C 89.49 36.94 90.00 37.00 90.00 37.00 C 90.06 35.42 86.84 36.03 86.00 36.00 C 86.92 36.18 87.36 37.20 89.00 37.00 Z" />
      </g>
      <g fill="#B84801" fill-opacity="0.84" stroke="None">
        <path d="M 91.00 60.00 C 93.37 58.27 95.50 56.44 98.00 55.00 C 94.40 54.22 91.70 52.85 93.00 48.00 C 102.48 51.39 101.21 59.95 101.00 69.00 C 100.79 78.05 101.16 89.71 101.00 99.00 C 91.32 90.78 80.18 84.45 71.00 76.00 C 71.00 76.00 70.37 75.78 70.00 76.00 C 70.71 82.61 81.10 83.78 84.23 88.77 C 87.36 93.76 96.69 95.89 99.00 101.00 C 99.19 101.41 99.00 102.00 99.00 102.00 C 110.08 98.42 103.11 82.22 105.00 72.00 C 106.89 61.78 105.55 48.74 94.00 46.00 C 94.20 42.53 94.22 37.51 90.00 37.00 C 90.00 37.00 89.49 36.94 89.00 37.00 C 92.16 40.08 92.71 55.79 91.00 60.00 Z" />
      </g>
      <g fill="#EB8326" fill-opacity="1.00" stroke="None">
        <path d="M 67.00 63.00 C 69.22 55.22 67.65 50.43 60.25 52.25 C 52.84 54.06 55.66 65.62 59.97 64.97 C 64.29 64.32 71.03 65.99 73.67 60.67 C 76.31 55.35 72.92 48.55 68.02 45.98 C 63.13 43.41 55.91 46.09 52.77 50.77 C 49.63 55.45 48.72 61.92 52.25 66.75 C 55.77 71.59 62.79 72.06 68.00 70.00 C 56.35 71.66 46.35 60.17 55.92 49.92 C 65.49 39.67 80.44 58.22 67.00 63.00 M 65.00 53.00 C 67.53 54.36 63.42 64.91 59.32 62.66 C 55.22 60.42 61.56 51.15 65.00 53.00 Z" />
      </g>
      <g fill="#E57520" fill-opacity="1.00" stroke="None">
        <path d="M 91.00 60.00 C 84.65 64.63 75.55 69.49 71.00 76.00 C 80.18 84.45 91.32 90.78 101.00 99.00 C 101.16 89.71 100.79 78.05 101.00 69.00 C 101.21 59.95 102.48 51.39 93.00 48.00 C 91.70 52.85 94.40 54.22 98.00 55.00 C 95.50 56.44 93.37 58.27 91.00 60.00 Z" />
      </g>
      <g fill="#E67621" fill-opacity="0.79" stroke="None">
        <path d="M 26.00 54.00 C 26.49 54.06 27.00 54.00 27.00 54.00 C 29.33 54.00 31.67 54.00 34.00 54.00 C 33.95 52.17 33.17 50.22 33.00 49.00 C 31.62 48.12 26.62 53.03 26.00 54.00 Z" />
      </g>
      <g fill="#FCCA3E" fill-opacity="1.00" stroke="None">
        <path d="M 65.00 53.00 C 61.56 51.15 55.22 60.42 59.32 62.66 C 63.42 64.91 67.53 54.36 65.00 53.00 Z" />
      </g>
      <g fill="#E77621" fill-opacity="0.97" stroke="None">
        <path d="M 23.00 94.00 C 23.16 94.92 24.73 96.39 24.00 98.00 C 35.90 93.71 44.07 80.30 56.00 76.00 C 49.88 70.01 41.02 64.02 34.00 59.00 C 31.54 57.25 28.89 56.90 27.00 54.00 C 27.00 54.00 26.49 54.06 26.00 54.00 C 25.00 54.00 24.00 54.00 23.00 54.00 C 23.00 67.33 23.00 80.67 23.00 94.00 Z" />
      </g>
      <g fill="#BB4D04" fill-opacity="1.00" stroke="None">
        <path d="M 34.00 59.00 C 33.62 57.53 34.04 55.52 34.00 54.00 C 31.67 54.00 29.33 54.00 27.00 54.00 C 28.89 56.90 31.54 57.25 34.00 59.00 Z" />
      </g>
      <g fill="#E77621" fill-opacity="0.97" stroke="None">
        <path d="M 57.00 76.00 C 54.33 82.39 45.64 83.38 41.30 88.30 C 36.96 93.23 29.40 96.41 25.00 101.00 C 26.66 100.80 27.04 101.79 28.00 102.00 C 50.49 103.31 73.46 102.00 96.00 102.00 C 96.55 101.88 97.82 100.20 99.00 101.00 C 96.69 95.89 87.36 93.76 84.23 88.77 C 81.10 83.78 70.71 82.61 70.00 76.00 C 67.30 77.61 66.80 74.00 64.01 74.01 C 61.22 74.01 59.54 75.40 57.00 76.00 Z" />
      </g>
      <g fill="#BD4D04" fill-opacity="0.98" stroke="None">
        <path d="M 24.00 98.00 C 23.56 98.16 23.00 98.00 23.00 98.00 C 23.07 98.91 22.72 100.79 24.00 101.00 C 24.49 101.08 25.00 101.00 25.00 101.00 C 29.40 96.41 36.96 93.23 41.30 88.30 C 45.64 83.38 54.33 82.39 57.00 76.00 C 57.00 76.00 56.44 75.84 56.00 76.00 C 44.07 80.30 35.90 93.71 24.00 98.00 Z" />
      </g>
      <g fill="#E77721" fill-opacity="0.47" stroke="None">
        <path d="M 23.00 98.00 C 23.00 98.00 23.56 98.16 24.00 98.00 C 24.73 96.39 23.16 94.92 23.00 94.00 C 23.00 95.32 22.91 96.68 23.00 98.00 Z" />
      </g>
      <g fill="#DE6F1C" fill-opacity="0.13" stroke="None">
        <path d="M 28.00 102.00 C 27.04 101.79 26.66 100.80 25.00 101.00 C 25.00 101.00 24.49 101.08 24.00 101.00 C 23.94 102.59 27.16 101.95 28.00 102.00 Z" />
      </g>
      <g fill="#E67721" fill-opacity="0.62" stroke="None">
        <path d="M 96.00 102.00 C 96.39 102.00 98.76 102.26 99.00 102.00 C 99.00 102.00 99.19 101.41 99.00 101.00 C 97.82 100.20 96.55 101.88 96.00 102.00 Z" />
      </g>
    </svg>
  );
};
export default SentIcon;
